export var SizingMethod;
(function (SizingMethod) {
    SizingMethod[SizingMethod["Fixed"] = 0] = "Fixed";
    SizingMethod[SizingMethod["CalcCanvasSize"] = 1] = "CalcCanvasSize";
    SizingMethod[SizingMethod["CalcTileSize"] = 2] = "CalcTileSize";
    SizingMethod[SizingMethod["CalcTileScale"] = 3] = "CalcTileScale";
})(SizingMethod || (SizingMethod = {}));
